import React, { Component, Fragment } from 'react';
import LocaleService from '../../Services/LocaleService.js';
import AdminService from '../../Services/AdminService.js';
import FormWithErrors from '../FormWithErrors.js';

class LocaleCreator extends Component {
	state = {
		key: null,
		name: null
	};

	constructor (props) {
		super(props);

    this.creationSubmit = this.creationSubmit.bind(this);
    this.adminService = new AdminService();
	}

	creationSubmit (value) {
		const that = this;

		return new Promise((resolve, reject) => {
			that.props.creator(that.state.key, that.state.name)
				.then(function (response) {
					that.props.adder(response);
					that.adminService.resetCachedTokens();
					resolve();
				})
				.catch(function (response) {
					const data = response.response.data;
					if (data.errors) {
						reject(data.errors);
					} else {
						throw response;
					}
				});
    });
	}

	handleParamChange = (param) => (e) => {
		let state = this.state;
		state[param] = e.target.value;
		this.setState(state);
	}

	render () {
		return (
      <Fragment>
        <div className="title">
          <span className="title-content">
          	<h1>Create</h1>
          </span>
        </div>
        <div className="content">
		      <FormWithErrors 
		      	key="locale.creator.form"
		      	onSubmit={this.creationSubmit} 
		      	renderitem={
		      		(i) =>
		      			<div className="field">
		      				{i}
		      			</div>
		    		}
		    	>
		        <input 
		        	type="text"
		        	className="input" 
		        	onChange={this.handleParamChange('key')} 
		        	placeholder="Locale Key (ie. nl_NL)" 
		        	attr="key"
		        />
		        <input 
		        	type="text" 
		        	className="input" 
		        	onChange={this.handleParamChange('name')} 
		        	placeholder="Language Name (Netherlands (Nederlands))"
		        	attr="name"
		        />
		        <input type="submit" className="button is-primary" value="Create" />
		       </FormWithErrors>
        </div>
      </Fragment>
		);
	}
}
export default LocaleCreator;


// WEBPACK FOOTER //
// ./src/Components/Locale/LocaleCreator.js